function shortenLines(lines: string[]): string[] {
  return lines.map(l => l.substring(0, 40))
}

function reduceLineNumbers(lines: string[]): string[] {
  return lines.slice(0, 3)
}

export { shortenLines, reduceLineNumbers };
